module.exports = __webpack_public_path__ + "img/info.007.f4680df3.jpeg";